export const BRAND_NAME = "Sitka Seafood Market";
export const BRAND_ALTERNATE_NAME = "Sitka Salmon Shares";